
















































































































































































































import { Component } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { BaseSideComponent } from "@/components/structure/MixinsSideComponent";
import { ActivitiesCommentsService } from "@/services/api/activities.comments.service";
import { ActivitiesFilesService } from "@/services/api/activities.files.service";
import ActivityPermissions from "@/permissions/activity.permissions";
import { NotificationServiceBus } from "@/services/bus/notifications.service";
import {
  ActivityCommentDto,
  ActivityFileDto,
  LanguageDto,
  ActivityAreaDto,
  ActivityDto,
  ActivityTypeDto
} from "@/server/app.dtos";
import { CreateActivityCommentCommand } from "@/server/app.commands";
import {
  GetActivityFilesDtosQuery,
  GetActivityCommentsDtosQuery
} from "@/server/app.queries";

@Component
export default class DetailActivitySideMenuComponent extends BaseSideComponent {
  CdnUrl: string = process.env.VUE_APP_CDN_URL;
  @Getter("currentLanguage") currentLanguage!: LanguageDto;
  activityPermissions: ActivityPermissions = new ActivityPermissions();
  activitiesFilesService: ActivitiesFilesService = new ActivitiesFilesService();
  activitiesCommentsService: ActivitiesCommentsService = new ActivitiesCommentsService();
  files: ActivityFileDto[] = [];
  comments: ActivityCommentDto[] = [];
  comment: CreateActivityCommentCommand = new CreateActivityCommentCommand();
  isLoading: boolean = false;
  isValid: boolean = false;

  constructor() {
    super();
    if (this.CdnUrl.endsWith("/")) {
      this.CdnUrl = this.CdnUrl.substring(0, this.CdnUrl.length - 1);
    }
  }

  get activity(): ActivityDto | null {
    return this.args?.activity || null;
  }

  get area(): ActivityAreaDto | null {
    return this.activity?.activityArea || null;
  }

  get type(): ActivityTypeDto | null {
    return this.activity?.activityType || null;
  }

  canView(): boolean {
    if (this.activity)
      return this.activityPermissions.canView(this.activity) || false;
    return false;
  }

  canEdit(): boolean {
    if (this.activity)
      return this.activityPermissions.canEdit(this.activity) || false;
    return false;
  }

  async created() {
    await this.loadComments();
    await this.loadFiles();
  }

  async loadComments() {
    if (this.activity) {
      const request = new GetActivityCommentsDtosQuery();
      request.isPublic = true;
      request.idActivity = this.activity.idActivity;
      await this.activitiesCommentsService
        .GetComments(request)
        .then(response => (this.comments = response.data));
    }
  }

  async loadFiles() {
    if (this.activity) {
      const request = new GetActivityFilesDtosQuery();
      request.isPublic = true;
      request.idActivity = this.activity.idActivity;
      await this.activitiesFilesService
        .GetFiles(request)
        .then(response => (this.files = response.data));
    }
  }

  createComment(): void {
    if (this.activity != null) {
      this.isLoading = true;
      this.comment.idActivity = this.activity.idActivity;
      this.activitiesCommentsService
        .CreateComment(this.comment)
        .then(() => {
          this.loadComments();
          this.comment.message = "";
          (this.$refs.form as any).resetValidation();
          NotificationServiceBus.showSuccessMessage(
            "Informação",
            "Comentário adicionado sucesso"
          );
        })
        .finally(() => (this.isLoading = false));
    }
  }
}
